import '@/config/rem'
import { parseUrl } from '@/utils'
import Vue from 'vue'
import App from './App.vue'
import { dingtalkAuth, globalConfig } from './config/auth'

Vue.config.productionTip = false
;(async function startUp() {
  try {
    window.GlobalConfig = parseUrl(globalConfig) //未实例化vue项目前就需要解析出参数
    window.$instance = new Vue({
      render: h => h(App),
      data: {
        eventHub: new Vue()
      }
    }).$mount('#app')

    // appStart(); //新版的不需要和后端交互判断是否已经授权了
    //钉钉配置了两个url，一个是授权展示页面url，一个是真实项目url，一旦用户授权之后，工作台应用你们就会替换成真实的项目接口，而不是需要这个展示页做相应的授权判断
    setTimeout(() => {
      dingtalkAuth()
    }, 500)
  } catch (error) {
    console.error(error) //eslint-disable-line
    alert(`出错了，请联系管理员解决${error.message}`)
  }
})()
